import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionMainTarget } from "./main-target";
import { QuestionPlanName } from "./name";

import type { DayTripPlanI18nCategoriesAndManagerStore } from "../../_store/categories";

type Props = {
	base: DayTripPlanI18nCategoriesAndManagerStore["base"];
};

export const QuestionPlanBase = ({ base }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionPlanName />
			<QuestionMainTarget />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanBase.displayName = "QuestionPlanBase";
